import { forwardRef } from 'react'
import toast from 'react-hot-toast'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

import { isSupportedFileType } from 'shared/helpers/file'
import { FileTypes } from 'shared/types/global'

const Input = styled.input.attrs({
  type: 'file'
})`
  display: none;
`

const MAX_FILE_SIZE = 5 * 1024 * 1024 // 5MB

type FileUploadProps = {
  onSelect: (file: File) => void
  type?: FileTypes
}

const FileUpload = forwardRef<HTMLInputElement, FileUploadProps>(
  ({ onSelect, type, ...rest }, ref) => {
    const { formatMessage } = useIntl()

    const handleChange: React.ChangeEventHandler<
      HTMLInputElement
    > = event => {
      const file = event.target.files?.[0]

      if (!file) {
        return
      }

      if (type === FileTypes.image && !isSupportedFileType(file)) {
        toast.error(
          formatMessage({
            id: 'FileUpload.image.wrongFormat'
          })
        )
        return
      }

      if (file.size > MAX_FILE_SIZE) {
        toast.error(
          formatMessage(
            { id: 'FileUpload.fileSizeExceeded' },
            { maxSize: '5MB' }
          )
        )
        return
      }

      onSelect(file)
      event.target.value = ''
    }

    return <Input {...rest} ref={ref} onChange={handleChange} />
  }
)

export default FileUpload
